import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCubes,
  faGem,
  faHeadphones,
  faCheckToSlot,
  faHouse,
  faBullhorn,
  faAward,
  faBoxArchive,
  faFileInvoice,
  faBuilding,
  faBookmark,
  faPlaneUp,
  faHome,
  faCity,
  faEarthAsia,
  faGear,
  faChevronLeft,
  faChevronRight,
  faBox,
  faRectangleList,
  faShuffle,
  faCreditCard,
  faTruck,
  faUsers,
  faBarsStaggered,
  faTruckArrowRight,
  faList,
  faFileInvoiceDollar,
  faDollarSign,
  faChartSimple,
  faInfoCircle,
  faThumbtack,
  faCalculator,
  faThumbtackSlash,
  faDroplet,
  faPersonHalfDress,
  faListAlt,
  faCalendar,
  faLayerGroup,
  faNewspaper,
  faCopyright,
  faTruckPickup,
  faLifeRing,
  faGift,
  faPercentage,
  faCartShopping,
  faImages,
  faPercent,
  faPhone,
  faComments,
  faCoins,
  faShield,
  faShieldHalved,
  faStore,
  faLink,
  faClipboardList,
  faStar,
  faRotateLeft,
  faTags,
  faWarehouse,
  faScaleBalanced,
  faRadio,
  faFileLines,
  faFolderTree,
  faClockRotateLeft,
  faUserShield,
  faKey,
  faMoneyCheckDollar,
  faTicket,
  faBuildingUser
} from '@fortawesome/free-solid-svg-icons';
import { faBell, faUser } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(
  faPhone,
  faCheckToSlot,
  faHouse,
  faBoxArchive,
  faFileInvoice,
  faBuilding,
  faBookmark,
  faBell,
  faPlaneUp,
  faHome,
  faCity,
  faEarthAsia,
  faGear,
  faChevronLeft,
  faChevronRight,
  faBox,
  faPercentage,
  faRectangleList,
  faShuffle,
  faCreditCard,
  faTruck,
  faBarsStaggered,
  faTruckArrowRight,
  faList,
  faFileInvoiceDollar,
  faChartSimple,
  faUsers,
  faUser,
  faDollarSign,
  faInfoCircle,
  faThumbtack,
  faThumbtackSlash,
  faCalculator,
  faDroplet,
  faPersonHalfDress,
  faListAlt,
  faImages,
  faLayerGroup,
  faNewspaper,
  faCopyright,
  faTruckPickup,
  faAward,
  faBullhorn,
  faLifeRing,
  faHeadphones,
  faCubes,
  faGem,
  faGift,
  faCartShopping,
  faCalendar,
  faPercent,
  faComments,
  faCoins,
  faShield,
  faShieldHalved,
  faStore,
  faLink,
  faClipboardList,
  faStar,
  faRotateLeft,
  faTags,
  faWarehouse,
  faScaleBalanced,
  faRadio,
  faFileLines,
  faFolderTree,
  faClockRotateLeft,
  faUserShield,
  faKey,
  faMoneyCheckDollar,
  faTicket,
  faBuildingUser
);

export const registerFontawesome = (app) => {
  app.component('FontAwesomeIcon', FontAwesomeIcon);
};
